const BasicFormCheckbox = ({text}) => {
	return (
		<div className={"flex pt-3"}>
			<input type={"checkbox"} style={{
				marginTop: "5.3px"
			}}/>
			<label style={{
				marginLeft: "10px"
			}}>{text}</label>
		</div>
	);
};

export default BasicFormCheckbox;
